import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import Textarea from "react-textarea-autosize";
import Revert from "../common/Revert";

const TextAreaInput = (props) => {
	const hasValue = !!props.value;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const value = props.value ? props.value : "";
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const info = props.tooltip ? <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.validationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
	const maxLength = props.maxLength ? props.maxLength : "";
	const id = generateGuid();

	const revertable = props.originalValue !== undefined ? props.originalValue !== props.value : false;

	const inputClassName = classnames({
		"c-input__field": true
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": hasValue
	});

	const containerClassName = classnames({
		"c-input": true,
		"has-value": hasValue,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": props.disabled
	});

	const textArea = (<Textarea
		id={id}
		minRows={props.height}
		value={value}
		disabled={props.disabled}
		onChange={props.onChange}
		className={inputClassName}
		name={props.name}
		maxLength={maxLength}
	/>);

	return (
		<div className={sizeClassName}>
			<div className={containerClassName}>
				{textArea}
				<label
					className={labelClassName}
					htmlFor={id}>
					{label}
				</label>
				{info}
				{!revertable || <Revert
					onChange={props.onChange}
					name={props.name}
					originalValue={props.originalValue} />}
			</div>
			{validation}
		</div>
	);
};

TextAreaInput.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	originalValue: PropTypes.string,
	maxLength: PropTypes.number,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	height: PropTypes.number
};

export default TextAreaInput;
